import { Box } from 'reflexbox';

import { useLocalize } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { QuillText, Snippet } from '@treams/treams-ui';

/**
 * The template's description, shown above the grid. Languages with an empty
 * delta are skipped so an untranslated language falls back to one with content.
 * Renders nothing when no language has a description.
 * @param props the template description
 * @param props.description the template's localized description
 */
export default function TalentReviewTemplateDescription(props: {
	description: graphql.TalentReviewTemplate['description'];
}) {
	const { localize } = useLocalize();
	const description = localize(
		props.description.filter((item) => !QuillText.isEmpty(item.text)),
	)?.text;

	if (QuillText.isEmpty(description)) {
		return null;
	}

	return (
		<Box mb={3}>
			<Snippet>
				<QuillText value={description} />
			</Snippet>
		</Box>
	);
}
